import * as types from './types'

export const mutations = {
	[types.ADD_OPERATION] (state, operation) {
		state.operations.push(operation)
	},
	[types.REPLACE_OPERATION] (state, operation) {
		state.operations = state.operations.map((op) => {
			if (op.id !== operation.id) {
				return op
			} else {
				return operation
			}
		})
	},
	[types.ADD_PRODUCT_TO_CONTRACT] (state, data) {
		state.contracts.filter((contract) => {
			return contract.id === data.contractId
		})[0].contract_products.push({ product: data.product })
	},
	[types.ADD_CONTRACT] (state, contract) {
		state.contracts.push(contract)
	},
	[types.CLEAR_OPERATIONS] (state) {
		state.operations = []
	},
	[types.CLEAR_CONTRACTS] (state) {
		state.contracts = []
	},
	[types.ADD_PRODUCT_TO_OPERATION] (state, data) {
		// console.log(state, data)
		// No need to add it for now, futhermore : the data sent by the api don't allow to correctly insert the value
	},
	[types.EDIT_PRODUCT_FROM_MISSION] (state, data) {
		// No need to do anything for now
	},
	[types.REMOVE_PRODUCT_FROM_OPERATION] (state, data) {
		const op = state.operations.filter(o => o.id === data.operationId)[0]
		let keyOfProduct = null
		op.mission_contract_products.forEach((mcp, key) => {
			if (mcp.id === data.product.id) {
				keyOfProduct = key
			}
		})

		op.mission_contract_products.splice(keyOfProduct, 1)
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Transactions/mutations.js